var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserFloat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_20208_60203)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 16,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#E3E8FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.2,
    y: 16.2,
    width: 49.6,
    height: 49.6,
    rx: 24.8,
    stroke: "#E2E2E8",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7603 55.3359C54.7603 50.9853 49.1173 47.4583 42.1562 47.4583C35.1951 47.4583 29.552 50.9853 29.552 55.3359M42.1562 42.7318C37.8055 42.7318 34.2786 39.2048 34.2786 34.8542C34.2786 30.5035 37.8055 26.9766 42.1562 26.9766C46.5068 26.9766 50.0338 30.5035 50.0338 34.8542C50.0338 39.2048 46.5068 42.7318 42.1562 42.7318Z",
    stroke: "#636980",
    strokeWidth: 1.8006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 44,
    width: 13.25,
    height: 13.25,
    rx: 6.625,
    fill: "#08C108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7777 54V48.8933H53.1455V54H51.7777ZM52.4667 48.1942C52.2235 48.1942 52.0208 48.1232 51.8587 47.9814C51.7033 47.8328 51.6257 47.647 51.6257 47.4241C51.6257 47.2012 51.7033 47.0188 51.8587 46.877C52.0208 46.7283 52.2235 46.654 52.4667 46.654C52.7166 46.654 52.9192 46.7283 53.0746 46.877C53.2367 47.0188 53.3178 47.2012 53.3178 47.4241C53.3178 47.647 53.2367 47.8328 53.0746 47.9814C52.9192 48.1232 52.7166 48.1942 52.4667 48.1942Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_20208_60203",
    x: 0,
    y: 0,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20208_60203"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20208_60203",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFloat);
export default __webpack_public_path__ + "static/media/userFloat.37cdf51706fafb8d4dc4db91ab1870a7.svg";
export { ForwardRef as ReactComponent };